import notes from '@nextories/vue-tasks/src/i18n/langs/fr/notes';

const defaultName = {
  ...notes.defaultName,
  projectNotSuccess: 'Dossier non remporté',
  reflectionProgress: 'Réflexion en cours',
  projectWaitting: 'Dossier en attente',
  datesToBeValided: 'Dates à valider',
  answering: 'Répondeur',
  renegotiation: 'Prix à renégocier',
  prestReview: 'Prestation à revoir',
  specToBeCorrect: 'Cahier des charges à corriger avant envoi',
};

export default {
  ...notes,
  selectName: defaultName,
};
